// extracted by mini-css-extract-plugin
module.exports = {"container-footer-recibos":"FooterLigaPago_container-footer-recibos__O_v6l","footer-copyright":"FooterLigaPago_footer-copyright__3kOzm"};